import React from "react";
import styled, { css } from "styled-components";

import recycleSrc from "../../assets/images/recycle-card.png";
import reduceSrc from "../../assets/images/reduce-card.png";
import reuseSrc from "../../assets/images/reuse-card.png";
import { SlideContainer  } from "./OurCommitment.styles";


const OurCommitmentSlide6 = () => {
  return (
    <SlideContainer style={{padding:"0px 20px"}}>
      <Reduce />
      <Reuse />
      <Recycle />
    </SlideContainer>
  );
};

const CSS = css`
  padding-top: 3rem;
  width: 100%;
`;

const Reduce = styled.img.attrs({
  src: reduceSrc,
})`
 width: 100%;
`;

const Reuse = styled.img.attrs({
  src: reuseSrc,
})`
  ${CSS}
`;

const Recycle = styled.img.attrs({
  src: recycleSrc,
})`
  ${CSS};
`;

export default OurCommitmentSlide6;
